module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1b_Image8g.c80657b5.jpg";